/* eslint-disable */
export default {
	translation: {
		navbar: {
			logo: 'Semorie',
			admin: 'Админ панель',
		},
		enterForm: {
			registration: 'Регистрация',
			enter: 'Вход',
			email: 'Почта', 
			password: 'Пароль',
			submit: 'Войти',
			err: {
				required: 'Заполните поле',
				network: 'Ошибка сети, проверьте подключение к интернету'
			}
		},
		signUpForm: {
			registration: 'Регистрация',
			email: 'Почта', 
			password: 'Пароль',
			confirmPassword: 'Повторите пароль',
			submit: 'Зарегистрироваться',
			err: {
				required: 'Заполните поле',
				network: 'Ошибка сети, проверьте подключение к интернету',
				email: 'Неверный формат почты',
				min: 'Минимум 6 символов',
				max: 'Максимум 20 символов',
				samePass: 'Пароли должны совпадать',
			}
		},
		shop: {
			categories: 'Категории',
			coating: 'Покрытие',
			rub: 'руб.',
			all: 'Все',
			any: 'Любое',
		},
		device: {
			shop: 'магазин',
			model: 'Модель',
			rating: 'Рейтинг',
			weigth: 'Вес',
			insert: 'Камни',
			evaluate: 'Оценить',
			selectEvaluate: 'Выберите оценку',
		},
		admin: {
			addCategory: 'Добавить категорию',
			addCoat: 'Добавить покрытие',
			addJewellery: 'Добавить украшение',
			nameCategory: 'Название категории',
			nameCoat: 'Название покрытия',
			deleteCategory: 'Удалить категорию',
			deleteCoat: 'Удалить покрытие',
			deleteJewellery: 'Удалить украшение',
			slectCategory: 'Выберите категорю',
			selectCoat: 'Выберите покрытие',
			selectName: 'Выберете название украшения',
			err: {
				twiceItems: 'Такое название уже есть',
				required: 'Заполните поле',
				number: 'Цена указывается цифрами',
				max: 'Максимум 10 символов',
				fullForm: 'Необходимо заполнить все поля формы'
			}
		},
		modal: {
			delete: 'Удалить',
			add: 'Добавить',
			close: 'Закрыть',
			name: 'Название украшения',
			price: 'Цена',
			addInfo: 'Добавить свойство',
			title: 'Название',
			description: 'Описание',
		}
	}
}